import api from "./api";
import { getQueue, removeFromQueue } from "./offlineStore";

let syncing = false;

export async function syncPendingInspections() {
  if (syncing || !navigator.onLine) return { synced: 0, remaining: getQueue().length };
  syncing = true;
  let synced = 0;
  try {
    for (const item of getQueue()) {
      try {
        await api.post("/inspections", item.payload);
        removeFromQueue(item.local_id);
        synced++;
      } catch (err) {
        if (!err.response) break; // still offline, stop and retry later
        removeFromQueue(item.local_id); // server rejected it, drop to avoid an infinite retry loop
      }
    }
  } finally {
    syncing = false;
  }
  return { synced, remaining: getQueue().length };
}
